module.exports = __webpack_public_path__ + "img/card.d2bbd0e6.png";